import script from "./RecentNotReply.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentNotReply.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__